import { render } from "./NewClaimYearSelector.vue?vue&type=template&id=d5ce2f7c&scoped=true&ts=true"
import script from "./NewClaimYearSelector.vue?vue&type=script&lang=ts"
export * from "./NewClaimYearSelector.vue?vue&type=script&lang=ts"

import "./NewClaimYearSelector.vue?vue&type=style&index=0&id=d5ce2f7c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_typescript@5.9.3__webpack@5.109.2_postcss@8.5.26_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5ce2f7c"]])

export default __exports__